import { render, staticRenderFns } from "./Itineraries.vue?vue&type=template&id=6537c4f7&scoped=true"
import script from "./Itineraries.vue?vue&type=script&lang=js"
export * from "./Itineraries.vue?vue&type=script&lang=js"
import style0 from "./Itineraries.vue?vue&type=style&index=0&id=6537c4f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6537c4f7",
  null
  
)

export default component.exports